
import { getPages } from 'component/pagination/utils'
import {
    ADD_PRODUCTS_TO_LIST_ERROR,
    ADD_PRODUCTS_TO_LIST_SUCCESS,
    CLEAR_PRICEBANNER_LIST,
    DELETE_PRICEBANNER_LIST_ERROR,
    DELETE_PRICEBANNER_LIST_SUCCESS,
    DELETE_PRICEBANNER_PRODUCT_ERROR,
    DELETE_PRICEBANNER_PRODUCT_SUCCESS,
    FETCH_PRICEBANNER_LIST_ERROR,
    FETCH_PRICEBANNER_LIST_SUCCESS,
    UPDATE_PRICEBANNER_LIST_ERROR,
    UPDATE_PRICEBANNER_LIST_SUCCESS,
    UPLOAD_PRICEBANNER_LIST_ERROR,
    UPLOAD_PRICEBANNER_LIST_SUCCESS,
    VALIDATE_PRICEBANNER_PRODUCTS_ERROR,
    VALIDATE_PRICEBANNER_PRODUCTS_SUCCESS,
} from 'constants/actionTypes'
import API_URL from 'constants/api'
import Api from 'utils/ApiRequest'
import { hideSpinner, showSpinner } from './spinner'
import { actionSet } from './utils'

export const fetchAll = (token, param) => async (dispatch) => {
  try {
    dispatch(showSpinner())
    const queryParams = new URLSearchParams(param).toString()
    const api = `${API_URL.FETCH_PRICEBANNER_LIST}?${queryParams}`
    const response = await new Api(token, dispatch).get(api)
    const { data, metadata } = response
    dispatch(getPages(data.pages))
    return dispatch(
      actionSet(FETCH_PRICEBANNER_LIST_SUCCESS, { data, metadata })
    )
  } catch (error) {
    return dispatch(actionSet(FETCH_PRICEBANNER_LIST_ERROR, error))
  } finally {
    dispatch(hideSpinner())
  }
}

const buildQueryParams = (params) => {
  const query = new URLSearchParams()
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      if (Array.isArray(value) && value.length > 0) {
        value.forEach(item => query.append(key, item))
      } else if (!Array.isArray(value)) {
        query.append(key, value)
      }
    }
  })
  return query
}

export const find = (token, param) => async (dispatch) => {
  try {
    dispatch(showSpinner())
    
    const productLms = param?.productLms
    const hasProductLms = Array.isArray(productLms) && productLms.length > 0
    
    if (hasProductLms) {
      const { productLms: _, ...urlParams } = param
      const queryParams = buildQueryParams(urlParams)
      
      const response = await new Api(token, dispatch).post(
        `${API_URL.FIND_PRICEBANNER_LIST}?${queryParams.toString()}`,
        productLms
      )
      const { data, metadata } = response
      dispatch(getPages(data.pages))
      return dispatch(actionSet(FETCH_PRICEBANNER_LIST_SUCCESS, { data, metadata }))
    }
    
    const queryParams = buildQueryParams(param)
    const response = await new Api(token, dispatch).get(`${API_URL.FIND_PRICEBANNER_LIST}?${queryParams.toString()}`)
    const { data, metadata } = response
    dispatch(getPages(data.pages))
    return dispatch(actionSet(FETCH_PRICEBANNER_LIST_SUCCESS, { data, metadata }))
  } catch (error) {
    return dispatch(actionSet(FETCH_PRICEBANNER_LIST_ERROR, error))
  } finally {
    dispatch(hideSpinner())
  }
}

const parseFilenameFromContentDisposition = (header) => {
  if (!header) return null
  const utf8Match = /filename\*=UTF-8''([^;]+)/i.exec(header)
  if (utf8Match) {
    try {
      return decodeURIComponent(utf8Match[1].trim())
    } catch (e) {
      return utf8Match[1].trim()
    }
  }
  const m = /filename="([^"]+)"/i.exec(header)
  if (m) return m[1]
  const m2 = /filename=([^;\s]+)/i.exec(header)
  return m2 ? m2[1].replace(/"/g, '') : null
}

const triggerBlobDownload = (blob, filename) => {
  const safeName = (filename || `produtos-em-lista-${new Date().toISOString().slice(0, 10)}.csv`)
    .replace(/[^a-zA-Z0-9._-]/g, '_')
  const href = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = href
  a.download = safeName
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(href)
}

export const downloadProductsReport = (token, param) => async (dispatch) => {
  const abortController = new AbortController()
  const cancelDownload = () => abortController.abort()

  try {
    // showSpinner(msg, isReactive, reactiveCallback) — o spinner global renderiza
    // o botão "Cancelar" quando isReactive=true e dispara reactiveCallback no clique.
    dispatch(showSpinner(undefined, true, cancelDownload))

    const productLms = param?.productLms
    const hasProductLms = Array.isArray(productLms) && productLms.length > 0
    const { productLms: _ignored, reportFileBaseName, ...rest } = param || {}
    const queryParams = buildQueryParams(rest)
    const url = `${API_URL.EXPORT_PRICEBANNER_PRODUCTS}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`

    const api = new Api(token, dispatch)
    // ApiRequest.headers() define Accept: application/json; o endpoint devolve text/csv
    // e o Spring responde 406 se o Accept do cliente não incluir CSV.
    const csvAcceptHeaders = {
      ...api.headers(url),
      Accept: 'text/csv;charset=UTF-8,text/csv,application/octet-stream,*/*',
    }

    let response
    if (hasProductLms) {
      response = await fetch(url, {
        method: 'POST',
        headers: csvAcceptHeaders,
        body: JSON.stringify(productLms),
        signal: abortController.signal,
      })
    } else {
      response = await fetch(url, {
        method: 'GET',
        headers: csvAcceptHeaders,
        signal: abortController.signal,
      })
    }

    if (response.status === 401 || response.status === 403) {
      const error = new Error('Sessão expirada ou não autorizada')
      error.cdStatus = response.status
      throw error
    }

    if (!response.ok) {
      const text = await response.text().catch(() => '')
      const error = new Error(text || `Falha ao baixar relatório (${response.status})`)
      error.cdStatus = response.status
      throw error
    }

    const blob = await response.blob()
    const dateStr = new Date().toISOString().slice(0, 10)
    const trimmedBase =
      reportFileBaseName != null && String(reportFileBaseName).trim()
        ? String(reportFileBaseName).trim()
        : ''
    const filename =
      trimmedBase
        ? `${trimmedBase}-${dateStr}.csv`
        : parseFilenameFromContentDisposition(response.headers.get('Content-Disposition'))
    triggerBlobDownload(blob, filename)

    return { success: true }
  } catch (error) {
    if (error?.name === 'AbortError' || abortController.signal.aborted) {
      const cancelled = new Error('Download cancelado pelo usuário')
      cancelled.cancelled = true
      throw cancelled
    }
    throw error
  } finally {
    dispatch(hideSpinner())
  }
}

export const update = (token, param) => async (dispatch) => {
  try {
    dispatch(showSpinner())
    const response = await new Api(token, dispatch).put(
      API_URL.UPDATE_PRICEBANNER_LIST,
      param
    )

    if (response.cdStatus === 409) {
      dispatch(actionSet(UPDATE_PRICEBANNER_LIST_ERROR, response))
      throw normalizeConflictProductError(response)
    }

    const { data } = response
    dispatch(actionSet(UPDATE_PRICEBANNER_LIST_SUCCESS, data))

    const invalidStores = Array.isArray(data) ? data : (data?.invalidStores || response?.invalidStores || [])
    return { data, invalidStores }
  } catch (error) {
    dispatch(actionSet(UPDATE_PRICEBANNER_LIST_ERROR, error))
    
    if (error.cdStatus === 409) {
      const normalizedError = normalizeConflictProductError(error)
      throw normalizedError
    }
    
    const invalidStores = Array.isArray(error?.data) ? error.data : (error?.data?.invalidStores || error?.invalidStores || [])
    if (invalidStores.length > 0 && error.cdStatus !== 409) {
      return { data: error.data, invalidStores, error }
    }    
    throw error
  } finally {
    dispatch(hideSpinner())
  }
}

export const deleteList = (token, cdPricebannerList) => async (dispatch) => {
  try {
    dispatch(showSpinner())
    await new Api(token, dispatch).post(API_URL.DELETE_PRICEBANNER_LIST, cdPricebannerList)
    dispatch(actionSet(DELETE_PRICEBANNER_LIST_SUCCESS))
    return true
  } catch (error) {
    dispatch(actionSet(DELETE_PRICEBANNER_LIST_ERROR, error))
    return false
  } finally {
    dispatch(hideSpinner())
  }
}

export const uploadList = (token, metadata, file) => async (dispatch) => {
  try {
    dispatch(showSpinner())
    const formData = new FormData()
    formData.append('metadata', new Blob([JSON.stringify(metadata)], { type: 'application/json' }))
    formData.append('file', file)
    const response = await new Api(token, dispatch).postFormData(
      API_URL.UPLOAD_PRICEBANNER_LIST,
      formData
    )

    if (response.cdStatus === 409) {
      dispatch(actionSet(UPLOAD_PRICEBANNER_LIST_ERROR, response))
      throw normalizeConflictProductError(response)
    }

    const { data } = response
    dispatch(actionSet(UPLOAD_PRICEBANNER_LIST_SUCCESS, data))

    const invalidStores = Array.isArray(data) ? data : (data?.invalidStores || response?.invalidStores || [])
    return { data, invalidStores }
  } catch (error) {
    dispatch(actionSet(UPLOAD_PRICEBANNER_LIST_ERROR, error))

    if (error.cdStatus === 409) {
      const normalizedError = normalizeConflictProductError(error)
      throw normalizedError
    }
    
    const invalidStores = Array.isArray(error?.data) ? error.data : (error?.data?.invalidStores || error?.invalidStores || [])
    if (invalidStores.length > 0 && error.cdStatus !== 409) {
      return { data: error.data, invalidStores, error }
    }
    throw error
  } finally {
    dispatch(hideSpinner())
  }
}

let shouldCancelBatchProcessing = false

export const validateProducts = (productLms, onProgress) => async (dispatch, getState) => {
  const token = getState().auth?.user?.dsToken
  if (!token) throw new Error('Token não disponível para validação')

  shouldCancelBatchProcessing = false

  const totalProducts = productLms.length

  const getBatchSize = (total) => {
    if (total < 10) return 1
    if (total <= 50) return 5
    if (total <= 100) return 10
    if (total <= 500) return 50
    return 100
  }

  const BATCH_SIZE = getBatchSize(totalProducts)
  const batches = []

  for (let i = 0; i < totalProducts; i += BATCH_SIZE) {
    batches.push(productLms.slice(i, i + BATCH_SIZE))
  }

  try {
    dispatch({
      type: 'VALIDATION_STARTED',
      payload: { totalProducts, startTime: Date.now(), totalBatches: batches.length }
    })

    const finalResult = {
      validProducts: {},
      invalidProducts: {},
      errors: []
    }

    for (let i = 0; i < batches.length; i++) {
      if (shouldCancelBatchProcessing) {
        finalResult.errors.push('Validation cancelled by user')
        break
      }

      const batch = batches[i]
      const processedSoFar = i * BATCH_SIZE

      if (onProgress) {
        onProgress({
          processed: processedSoFar,
          total: totalProducts,
          currentBatch: i + 1,
          totalBatches: batches.length,
          percentage: Math.round((processedSoFar / totalProducts) * 100)
        })
      }

      dispatch({
        type: 'VALIDATION_PROGRESS',
        payload: {
          processed: processedSoFar,
          total: totalProducts,
          currentBatch: i + 1,
          totalBatches: batches.length,
          percentage: Math.round((processedSoFar / totalProducts) * 100)
        }
      })

      // eslint-disable-next-line no-await-in-loop
      const response = await new Api(token, dispatch).post(
        API_URL.VALIDATE_PRICEBANNER_PRODUCTS,
        batch
      )

      const batchResult = response.data

      if (batchResult.validProducts) {
        Object.assign(finalResult.validProducts, batchResult.validProducts)
      }
      if (batchResult.invalidProducts) {
        Object.assign(finalResult.invalidProducts, batchResult.invalidProducts)
      }
      if (batchResult.errors) {
        finalResult.errors.push(...batchResult.errors)
      }
    }

    if (onProgress) {
      onProgress({
        processed: totalProducts,
        total: totalProducts,
        currentBatch: batches.length,
        totalBatches: batches.length,
        percentage: 100
      })
    }

    dispatch({
      type: 'VALIDATION_COMPLETED',
      payload: {
        endTime: Date.now(),
        totalProducts,
        validProducts: Object.keys(finalResult.validProducts || {}).length,
        invalidProducts: Object.keys(finalResult.invalidProducts || {}).length
      }
    })

    dispatch(actionSet(VALIDATE_PRICEBANNER_PRODUCTS_SUCCESS, finalResult))
    return finalResult

  } catch (error) {
    dispatch({
      type: 'VALIDATION_ERROR',
      payload: {
        error: error.message || 'Erro na validação',
        endTime: Date.now(),
        totalProducts
      }
    })

    dispatch(actionSet(VALIDATE_PRICEBANNER_PRODUCTS_ERROR, error))
    throw error
  }
}

export const cancelValidation = () => async (dispatch, getState) => {
  const token = getState().auth?.user?.dsToken
  if (!token) return

  shouldCancelBatchProcessing = true

  try {
    await new Api(token, dispatch).post(
      `${API_URL.VALIDATE_PRICEBANNER_PRODUCTS}/cancel`
    )
    // eslint-disable-next-line no-empty
  } catch (error) {
  }
}

export const validateBranches = (branchCodes) => async (dispatch, getState) => {
  const token = getState().auth?.user?.dsToken
  if (!token) throw new Error('Token não disponível para validação')

  const codes = Array.isArray(branchCodes) ? branchCodes : []
  if (codes.length === 0) {
    return { validBranches: {}, invalidBranches: {} }
  }

  const response = await new Api(token, dispatch).post(
    API_URL.VALIDATE_PRICEBANNER_BRANCHES,
    codes
  )

  const data = response.data || {}
  return {
    validBranches: data.validBranches || {},
    invalidBranches: data.invalidBranches || {}
  }
}

export const addProductsToList = (token, listId, param = {}) => async (dispatch) => {
  try {
    dispatch(showSpinner())
    const {
      productLms = [],
      productDescriptions = {},
      productExtrasByLm,
      productBranchesByLm,
      productBranchExtrasByLm,
      idBranchesFromFile,
    } = param

    const payload = {
      productLms,
      productDescriptions,
      ...(productExtrasByLm &&
        typeof productExtrasByLm === 'object' &&
        Object.keys(productExtrasByLm).length > 0 && { productExtrasByLm }),
      ...(productBranchesByLm &&
        typeof productBranchesByLm === 'object' &&
        Object.keys(productBranchesByLm).length > 0 && { productBranchesByLm }),
      ...(productBranchExtrasByLm &&
        typeof productBranchExtrasByLm === 'object' &&
        Object.keys(productBranchExtrasByLm).length > 0 && { productBranchExtrasByLm }),
      ...(Array.isArray(idBranchesFromFile) &&
        idBranchesFromFile.length > 0 && { idBranchesFromFile }),
    }
    const response = await new Api(token, dispatch).post(
      `${API_URL.ADD_PRODUCTS_TO_LIST}?listId=${listId}`,
      payload
    )

    if (response.cdStatus === 409) {
      dispatch(actionSet(ADD_PRODUCTS_TO_LIST_ERROR, response))
      throw normalizeConflictProductError(response)
    }

    dispatch(actionSet(ADD_PRODUCTS_TO_LIST_SUCCESS, response))

    const data = response?.data
    const invalidStores = Array.isArray(data)
      ? data
      : (data?.invalidStores || response?.invalidStores || [])
    return { ...response, invalidStores }
  } catch (error) {
    dispatch(actionSet(ADD_PRODUCTS_TO_LIST_ERROR, error))

    if (error.cdStatus === 409) {
      const normalizedError = normalizeConflictProductError(error)
      throw normalizedError
    }

    const invalidStores = Array.isArray(error?.data)
      ? error.data
      : (error?.data?.invalidStores || error?.invalidStores || [])
    if (invalidStores.length > 0 && error.cdStatus !== 409) {
      return { data: error.data, invalidStores, error }
    }

    throw error
  } finally {
    dispatch(hideSpinner())
  }
}

export const deleteProductFromList = (token, idPriceBannerList, idPriceBannerProductOrIds) => async (dispatch) => {
  try {
    dispatch(showSpinner())
    
    const isBatch = Array.isArray(idPriceBannerProductOrIds)
    let apiUrl
    
    if (isBatch) {
      apiUrl = `${API_URL.DELETE_PRICEBANNER_PRODUCT}?idPriceBannerList=${idPriceBannerList}`
      const response = await new Api(token, dispatch).post(apiUrl, idPriceBannerProductOrIds)

      if (response.cdStatus && response.cdStatus >= 400) {
        const error = new Error(response.message || 'Error deleting products')
        error.cdStatus = response.cdStatus
        error.response = response
        dispatch(actionSet(DELETE_PRICEBANNER_PRODUCT_ERROR, error))
        throw error
      }
      
      dispatch(actionSet(DELETE_PRICEBANNER_PRODUCT_SUCCESS, response))
      return response
    }
    apiUrl = `${API_URL.DELETE_PRICEBANNER_PRODUCT}?idPriceBannerList=${idPriceBannerList}&idPriceBannerProduct=${idPriceBannerProductOrIds}`
    const response = await new Api(token, dispatch).post(apiUrl)
    dispatch(actionSet(DELETE_PRICEBANNER_PRODUCT_SUCCESS, response))
    return response
  } catch (error) {
    dispatch(actionSet(DELETE_PRICEBANNER_PRODUCT_ERROR, error))
    throw error
  } finally {
    dispatch(hideSpinner())
  }
}

export const clearPriceBannerList = () => (dispatch) => dispatch(actionSet(CLEAR_PRICEBANNER_LIST))

export const normalizeConflictProductError = (responseOrError) => {
  const errorResponse = { 
    ...responseOrError,
    cdStatus: responseOrError.cdStatus || 409
  };

  let conflictingLms = [];
  if (Array.isArray(responseOrError?.data) && responseOrError.data.length > 0) {
    if (typeof responseOrError.data[0] === 'string') {
      conflictingLms = responseOrError.data;
    }
  }
  
  if (!conflictingLms.length && responseOrError?.conflictingLms) {
    conflictingLms = responseOrError.conflictingLms;
  }
  
  if (!conflictingLms.length && responseOrError?.data?.conflictingLms) {
    conflictingLms = responseOrError.data.conflictingLms;
  }

  let productLms = [];
  if (responseOrError?.data?.productLms) {
    productLms = responseOrError.data.productLms;
  } else if (responseOrError?.productLms) {
    productLms = responseOrError.productLms;
  } else if (responseOrError?.payload?.productLms) {
    productLms = responseOrError.payload.productLms;
  }

  if (!productLms.length && !Array.isArray(responseOrError?.data) && responseOrError?.data?.productLms) {
    productLms = responseOrError.data.productLms;
  }

  errorResponse.conflictingLms = Array.isArray(conflictingLms) ? conflictingLms : [];
  errorResponse.productLms = Array.isArray(productLms) ? productLms : [];

  return errorResponse;
}